import type { FC } from 'react';
import React from 'react';

export const ScorePlaceIcon: FC = () => (
    <svg fill="none" height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_330_4697)">
            <path
                d="M0.65024 10.2631C1.37785 5.17942 5.17942 1.37785 10.2631 0.65024C12.8582 0.278824 16.1038 0 20 0C23.8962 0 27.1418 0.278824 29.7369 0.65024C34.8206 1.37785 38.6221 5.17942 39.3498 10.2631C39.7212 12.8582 40 16.1038 40 20C40 23.8962 39.7212 27.1418 39.3498 29.7369C38.6221 34.8206 34.8206 38.6221 29.7369 39.3498C27.1418 39.7212 23.8962 40 20 40C16.1038 40 12.8582 39.7212 10.2631 39.3498C5.17942 38.6221 1.37785 34.8206 0.65024 29.7369C0.278824 27.1418 0 23.8962 0 20C0 16.1038 0.278824 12.8582 0.65024 10.2631Z"
                fill="#FF0002"
            />
            <g clipPath="url(#clip1_330_4697)">
                <path
                    d="M4.62988 28.889V17.885H16.4138V11.2964H35.3706V28.889H4.62988Z"
                    fill="white"
                />
                <path
                    d="M11.017 25.4051H10.7779L9.58245 20.3688H7.32812V26.4744H8.48944V21.4381H8.72854L9.92401 26.4744H11.9051L13.1006 21.4381H13.3396V26.4744H14.501V20.3688H12.2466L11.017 25.4051ZM22.8693 26.4744H27.0022V25.4051H24.0648V23.8873H26.5923V22.8524H24.0648V21.4381H27.0022V20.3688H22.8693V26.4744ZM18.7022 25.5776C17.3701 25.5776 16.7553 24.6462 16.7553 23.4044C16.7553 22.1625 17.3701 21.2656 18.7022 21.2656C20.0343 21.2656 20.6491 22.197 20.6491 23.4044C20.6491 24.6117 20.0343 25.5776 18.7022 25.5776ZM18.7022 20.1963C16.687 20.1963 15.5257 21.5071 15.5257 23.4044C15.5257 25.3016 16.687 26.6469 18.7022 26.6469C20.7174 26.6469 21.8787 25.3016 21.8787 23.4044C21.8787 21.5071 20.7174 20.1963 18.7022 20.1963ZM27.822 26.4744H29.0857L30.4861 24.0598L32.0232 26.4744H33.287L31.2717 23.2664L33.1845 20.3688H31.8866L30.5545 22.542L29.2224 20.3688H27.9244L29.7689 23.2319L27.822 26.4744Z"
                    fill="#FF0002"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_330_4697">
                <rect fill="white" height="40" width="40" />
            </clipPath>
            <clipPath id="clip1_330_4697">
                <rect
                    fill="white"
                    height="17.5926"
                    transform="translate(4.62988 11.2964)"
                    width="30.7407"
                />
            </clipPath>
        </defs>
    </svg>
);
